export default __webpack_public_path__ + "locales/az/People.json?hash=66f8ee8b1170bcb149f7319d1e059e2a";